<template>
  <div class="a2p-field" :class="{ filled: isFilled }">
    <div class="a2p-field-head">
      <div class="a2p-field-num">{{ num }}</div>
      <div class="a2p-field-label">
        <slot name="label">{{ label }}</slot>
        <span v-if="sub" class="a2p-field-sub">{{ sub }}</span>
        <span v-if="pill" class="a2p-field-pill">{{ pill }}</span>
      </div>
    </div>
    <div v-if="help" class="a2p-field-help" v-html="help"></div>
    <div v-if="example" class="a2p-field-example">{{ example }}</div>
    <div class="a2p-field-input-wrap">
      <slot />
    </div>
    <div v-if="validation" class="a2p-field-validation" :class="validation.level">
      <span v-if="validation.level === 'ok'">✓ </span>
      <span v-else-if="validation.level === 'err'">✗ </span>
      <span v-else-if="validation.level === 'warn'">⚠ </span>
      {{ validation.msg }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'A2PField',
  props: {
    num: { type: [String, Number], required: true },
    label: { type: String, default: '' },
    sub: { type: String, default: '' },
    pill: { type: String, default: '' },
    help: { type: String, default: '' },
    example: { type: String, default: '' },
    validation: { type: Object, default: null },
    value: { type: [String, Number, Array, Boolean, Object], default: '' },
  },
  computed: {
    isFilled() {
      if (this.validation && this.validation.level === 'ok') return true;
      if (Array.isArray(this.value)) return this.value.length > 0;
      return !!(this.value && String(this.value).trim() !== '');
    },
  },
};
</script>
